import { Row } from "antd";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import KeyFeature from "../../components/KeyFeature/KeyFeature";
import {
  FORM_FIELDS_LOOKUP,
  FORM_FIELDS_TYPE,
  HELPER_TEXT_KEYS,
  LAND_REQUIRED_FIELDS_LOOKUP,
  LAND_TABS_KEYS,
  PROPERTY_KEY_FEATURE_TEMPLATE_KEYS,
} from "../../utils/constants";
import { validateMarketingDescription } from "../../utils/utils";

const KeyFeatures = ({ viewOnlyMode, form, templateList, auditPanelDrawerVisible }) => {
  const { lookupList } = useSelector(state => state.helperText);
  const { t } = useTranslation();

  const fieldsType = FORM_FIELDS_TYPE.regular;

  return (
    <>
      <Row className="fields-row" gutter={20}>
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature1]}
          label="KeyFeatures.KeyFeature1"
          name={["keyFeatures", "feature1"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature1.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature1.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              required: LAND_REQUIRED_FIELDS_LOOKUP[fieldsType].keyFeatures.feature1,
              message: t("LandInfo.KeyFeature1RulesMessage"),
            },
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature1WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature1")),
            },
          ]}
        />
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature2]}
          label="KeyFeatures.KeyFeature2"
          name={["keyFeatures", "feature2"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature2.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature2.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              required: LAND_REQUIRED_FIELDS_LOOKUP[fieldsType].keyFeatures.feature2,
              message: t("LandInfo.KeyFeature2RulesMessage"),
            },
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature2WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature2")),
            },
          ]}
        />
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature3]}
          label="KeyFeatures.KeyFeature3"
          name={["keyFeatures", "feature3"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature3.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature3.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature3WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature3")),
            },
          ]}
        />
      </Row>
      <Row className="fields-row" gutter={20}>
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature4]}
          label="KeyFeatures.KeyFeature4"
          name={["keyFeatures", "feature4"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature4.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature4.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature4WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature4")),
            },
          ]}
        />
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature5]}
          label="KeyFeatures.KeyFeature5"
          name={["keyFeatures", "feature5"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature5.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature5.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature5WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature5")),
            },
          ]}
        />
        <KeyFeature
          parentId="landInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.land.keyFeature6]}
          label="KeyFeatures.KeyFeature6"
          name={["keyFeatures", "feature6"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature6.templateKey]}
          tab={LAND_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.land.keyFeatures.feature6.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          rules={[
            {
              whitespace: true,
              message: t("LandInfo.KeyFeature6WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature6")),
            },
          ]}
        />
      </Row>
    </>
  );
};
KeyFeatures.propTypes = {
  viewOnlyMode: PropTypes.bool,
  form: PropTypes.object,
  templateList: PropTypes.array,
  auditPanelDrawerVisible: PropTypes.bool,
};
export default KeyFeatures;
